module.exports = __webpack_public_path__ + "static/media/mockup.b753b8ee.png";